<template>
  <form id="formCostumerData" v-on:submit.prevent="submitForm()">
    <modal-component id="costumerData" modal-type="modal-lg">
      <template v-slot:title>Dados do Cliente</template>

      <template v-slot:default>
        <!-- toggle search section -->
        <div v-if="modalMode == 'schedule' || modalMode == 'callback'" id="modalCostumerSearch" class="row mb-3">
          <div class="col-12">
            <costumers-select-component :disabled="false" :required="true" :readonly="false"></costumers-select-component>
          </div>
        </div>

        <!-- costumer data -->
        <div class="row" id="modalCostumerData">
          <div class="col-12">
            <h3>Dados de cadastro</h3>
          </div>

          <!-- <div class="col-4">
            <select-component
              id="client_type"
              name="client_type"
              icon="fas fa-user-circle"
              title="Tipo de Cadastro"
              :disabled="disableInputs"
              :enable-all="false"
              :values="[{id: 'client', name: 'Cliente'},{id: 'lead', name: 'Lead'}]"
            />
          </div> -->
          <input type="hidden" name="first_hidden"  id="a-first"/>
          <input type="hidden" name="cpf_cnpj_hidden" id= "a-cpf" />
          <input type="hidden" name="corporate_name_hidden" id="a-corporate" />
          <div class="col-4">
            <input-component
              id="fantasy_name"
              name="first"
              icon="fas fa-user-circle"
              title="Nome"
              :disabled="disableInputs"
            />
          </div>
          <div class="col-4">
            <input-component
              id="corporate_name"
              name="corporate_name"
              icon="fas fa-user-circle"
              title="RG"
              :disabled="disableInputs"
            />
          </div>
          <div class="col-4" v-if="modalMode == 'default'">
            <input-component
              id="telphone"
              name="telphone"
              icon="fas fa-phone-alt"
              title="Telefone 1"
              :disabled="disableInputs"
            />
          </div>
          <div class="col-4" v-if="modalMode == 'default'">
            <input-component
              id="cellphone"
              name="cellphone"
              icon="fas fa-phone-alt"
              title="Telefone 2"
              :disabled="disableInputs"
            />
          </div>

          <div class="col-4">
            <input-component
              id="cpf_cpnj"
              name="cpf_cnpj"
              icon="fas fa-phone-alt"
              title="CPF/CNPJ"
              :disabled="disableInputs"
            />
          </div>

          <div class="col-4" v-if="modalMode != 'default'">
            <select-component
              type="datalist"
              id="phones_list"
              name="schedulePhone"
              icon="fas fa-phone-alt"
              title="Telefone"
              :disabled="false"
              :required="true"
            />
          </div>
        </div>

        <!-- toggle address info -->
        <div v-if="modalMode == 'default'" id="modalCostumerAddress" class="row mt-3">
          <input type="hidden" name="id" id="costumerId" />

          <div class="col-12">
            <h3>Endereço</h3>
          </div>
          <div class="col-3">
            <input-component
              id="cep"
              name="cep"
              icon="fas fa-map"
              title="CEP"
              :disabled="disableInputs"
              :required="true"
              v-on:change="viacep"
            />
          </div>
          <div class="col-3">
            <input-component
              id="city"
              name="city"
              icon="fas fa-map"
              title="Cidade"
              :disabled="disableInputs"
              :required="true"
            />
          </div>
          <div class="col-3">
            <select-component
              id="uf"
              name="uf"
              icon="fas fa-map"
              title="UF"
              :required="true"
              :disabled="disableInputs"
              :enable-all="false"
              :values="[{id: 'AC', name: 'AC'},
              {id: 'AL', name: 'AL'},
              {id: 'AP', name: 'AP'},
              {id: 'AM', name: 'AM'},
              {id: 'BA', name: 'BA'},
              {id: 'CE', name: 'CE'},
              {id: 'DF', name: 'DF'},
              {id: 'ES', name: 'ES'},
              {id: 'GO', name: 'GO'},
              {id: 'MA', name: 'MA'},
              {id: 'MT', name: 'MT'},
              {id: 'MS', name: 'MS'},
              {id: 'MG', name: 'MG'},
              {id: 'PA', name: 'PA'},
              {id: 'PB', name: 'PB'},
              {id: 'PR', name: 'PR'},
              {id: 'PE', name: 'PE'},
              {id: 'PI', name: 'PI'},
              {id: 'RJ', name: 'RJ'},
              {id: 'RN', name: 'RN'},
              {id: 'RS', name: 'RS'},
              {id: 'RO', name: 'RO'},
              {id: 'RR', name: 'RR'},
              {id: 'SC', name: 'SC'},
              {id: 'SP', name: 'SP'},
              {id: 'SE', name: 'SE'},
              {id: 'TO', name: 'TO'}]"
            />
          </div>
          <div class="col-3">
            <input-component
              id="address"
              name="address"
              icon="fas fa-map"
              title="Logradouro"
              :disabled="disableInputs"
              :required="true"
            />
          </div>
          <div class="col-4">
            <input-component
              id="number"
              name="number"
              icon="fas fa-map"
              title="Número"
              :disabled="disableInputs"
            />
          </div>
          <div class="col-4">
            <input-component
              id="district"
              name="district"
              icon="fas fa-map"
              title="Bairro"
              :disabled="disableInputs"
              :required="true"
            />
          </div>
          <div class="col-4">
            <input-component
              id="complement"
              name="complement"
              icon="fas fa-map"
              title="Complemento"
              :disabled="disableInputs"
            />
          </div>
        </div>

        <!-- schedule mode -->
        <div v-if="modalMode === 'schedule' || modalMode === 'callback'" id="modalCostumerSchedule" class="row mt-3">
          <!-- hidden inputs -->
          <div v-if="modalMode === 'schedule'">
          <input type="hidden" name="scheduleId" id="scheduleId" />
          </div>
          <div v-if="modalMode === 'callback'">
          <input type="hidden" name="callbackId" id="callbackId" />
          </div>
          <div class="col-12">
            <h3>Agendamento</h3>
          </div>
          <div class="col-6">
            <div class="row" v-if=renderizar >
              <div class="col-12">
                <select-component
                  data-type="usersList"
                  icon="fas fa-users"
                  title="Responsável"
                  name="at_user_id"
                  :enable-all="false"
                  :required="true"
                  :disabled="false"
                ></select-component>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <input-component
                  id="date"
                  name="date"
                  type="date"
                  icon="fas fa-calendar-day"
                  title="Data"
                  :required="true"
                  :disabled="false"
                  :readonly="false"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <input-component
                  id="hour"
                  name="hour"
                  type="time"
                  icon="fas fa-clock"
                  title="Hora"
                  :required="true"
                  :disabled="false"
                  :readonly="false"
                />
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="col-12">
              <textarea-component
                icon="fas fa-paragraph"
                id="description"
                name="description"
                title="Descrição"
                :required="true"
                :disabled="false"
              />
            </div>
          </div>
        </div>
      </template>

      <template v-slot:footer>
        <!-- schedule footer -->
        <button id="saveButton" type="submit" class="btn btn-success">
          <i class="fas fa-save"></i> Salvar
        </button>

        <div id="editButton" hidden>
          <button type="button" class="btn btn-primary" v-on:click="edit()">
            <i class="fas fa-edit"></i> Editar
          </button>
        </div>

        <div id="editingButtons" hidden>
          <button type="button" class="btn btn-success" v-on:click="saveEdit()">
            <i class="fas fa-save"></i> Salvar
          </button>
          <button type="button" class="btn btn-danger" v-on:click="destroy()">
            <i class="fas fa-times"></i> Excluir
          </button>
          <button type="button" class="btn btn-secondary" v-on:click="cancelEdit()">
            <i class="fas fa-window-close"></i> Cancelar
          </button>
        </div>
        <button data-dismiss="modal" type="button" class="btn btn-danger">
          <i class="fas fa-window-close fa-fw"></i> Fechar
        </button>
      </template>
    </modal-component>
  </form>
</template>

<script>
export default {
  props: {
    disableInputs: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: "default" //schedule, callback or default
    },
    renderizar: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      modalMode: this.mode,
      url: window.location.pathname
    };
  },
  mounted() {
    const self = this;

    $("#costumerData").on("hidden.bs.modal", function(event) {
      let saveButton = document.getElementById("saveButton");
      let editButton = document.getElementById("editButton");
      // let editingButtons = documinputphones_listent.getElementById("editingButtons");

      saveButton.removeAttribute("hidden");
      editingButtons.setAttribute("hidden", true);
      editButton.setAttribute("hidden", true);

      let modalCostumerData = document.getElementById("modalCostumerData");
      modalCostumerData
        .querySelectorAll("input, select, textarea")
        .forEach(element => {
          element.setAttribute("disabled", true);
          element.value = "";
        });

      if (self.modalMode == "schedule") {

        let searchInput = document.getElementById("modalCostumerSearch");
        searchInput.removeAttribute("hidden");
        let modalInputs = document.getElementById("modalCostumerSchedule");
        modalInputs
          .querySelectorAll("input, select, textarea")
          .forEach(element => {
            element.removeAttribute("disabled");
            element.value = "";
          });

        let listphones_list = document.querySelector("#listphones_list");
        document.getElementById("inputphones_list").removeAttribute("disabled");
        let listphones_list_options = listphones_list.querySelectorAll(
          "option"
        );
        $(listphones_list)
          .val("")
          .find("option")
          .remove();
      }
    });
  },

  methods: {
    changeMode(data){
      this.modalMode = data
    },

    viacep(value) {
      if (value.length >= 7) {
        this.$viaCep.buscarCep(value).then(obj => {
          let fields = {
            cep: obj.cep,
            address: obj.logradouro,
            complement: obj.complemento,
            district: obj.bairro,
            uf: obj.uf,
            city: obj.localidade
          };
          const formCostumerData = document.getElementById("formCostumerData");
          populate(formCostumerData, fields);
        });
      }
    },

    async submitForm() {
      const formCostumerData = document.getElementById("formCostumerData");
      const formData = new FormData(formCostumerData);
      let path;

      if (this.modalMode == "default") {
        path = '/create';
      }
      if (this.modalMode == "callback") {
        path = '/createSchedule';
      }
      if (this.modalMode == 'schedule') {
        path = '/schedule/create';
      }
      console.log(formData);
      await axios
        .post(this.url + `${path}`, formData, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(response => {
          let saveButton = document.getElementById("saveButton");
          let editButton = document.getElementById("editButton");
          saveButton.setAttribute("hidden", true);
          editButton.removeAttribute("hidden");

          this.alertCallback(response.data);

          if (this.modalMode == "schedule") {
            document.getElementById("scheduleId").value = response.data.id;
            document
              .getElementById("inputphones_list")
              .setAttribute("disabled", true);
          }else{
            document.getElementById("costumerId").value = response.data.id;
          }
          this.cancelEdit();

          socket.emit("new-schedule", response.data);
          if(window.dt){
            window.dt.reload();
          }
          return;
        })
        .catch(error => {
          console.error("[methods -> submitForm()]:", error);
          return Swal.fire({
            type: "error",
            title: "Erro!",
            text: "Falha ao realizar a ação."
          });
        });
    },

    alertCallback(data) {
      var type = new Array();
      type["schedule"] = () => {
        return Swal.fire({
          type: "success",
          title: "Feito!",
          text: "Agendamento realizado com sucesso."
        });
      };

      type["callback"] = () => {
        return Swal.fire({
          type: "success",
          title: "Feito!",
          text: "Callback angendado com sucesso."
        });
      };

      type["default"] = () => {
        return Swal.fire({
          type: "success",
          title: "Feito!",
          text: "Cadastro salvo com sucesso."
        });
      };
      return type[this.modalMode]();
    },

    edit() {
      let saveButton = document.getElementById("saveButton");
      let editButton = document.getElementById("editButton");
      let editingButtons = document.getElementById("editingButtons");
      saveButton.setAttribute("hidden", true);
      editButton.setAttribute("hidden", true);
      editingButtons.removeAttribute("hidden");

      if (this.modalMode == "schedule" || this.modalMode == "callback") {
        document.getElementById("inputphones_list").removeAttribute("disabled");

        let modalCostumerSchedule = document
          .getElementById("modalCostumerSchedule")
          .querySelectorAll("input, select, textarea");
        modalCostumerSchedule.forEach(element => {
          element.removeAttribute("disabled");
        });
      }else{
        let formCostumerData = document
          .getElementById("formCostumerData")
          .querySelectorAll("input, select, textarea");
        formCostumerData.forEach(element => {
          element.removeAttribute("disabled");
        });
      }
    },

    cancelEdit() {
      let saveButton = document.getElementById("saveButton");
      let editButton = document.getElementById("editButton");
      let editingButtons = document.getElementById("editingButtons");
      saveButton.setAttribute("hidden", true);
      editingButtons.setAttribute("hidden", true);
      editButton.removeAttribute("hidden");

      if (this.modalMode == "schedule" ||this.modalMode == "callback") {
        document
          .getElementById("inputphones_list")
          .setAttribute("disabled", true);
        let modalInputs = document
          .getElementById("modalCostumerSchedule")
          .querySelectorAll("input, select, textarea");
        modalInputs.forEach(element => {
          element.setAttribute("disabled", true);
        });
      }

      if (this.modalMode == "default") {
        let modalInputs = document.getElementById("costumerData").querySelectorAll("input, select, textarea");
        modalInputs.forEach(element => {
          element.setAttribute("disabled", true);
        });
      }
    },

    saveEdit() {
      const form = document.getElementById("formCostumerData");
      let id;
      let path;
      if (this.modalMode == "default") {
        id = document.getElementById("costumerId").value;
        path = '/update/';
      }
      if (this.modalMode == "callback") {
        id = document.getElementById("callbackId").value;
        path = '/updateSchedule/';
      }
      if (this.modalMode == 'schedule') {
        id = document.getElementById("scheduleId").value;
        // path = '/update/';
          id = document.getElementById("scheduleId").value;
          path = '/scheduleUpdateData/';
      }
      const formData = new FormData(form);
      axios
        .post(this.url + `${path}` + id, formData, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(response => {
          Swal.fire({
            type: "success",
            title: "Feito!",
            text: "Atualizado com sucesso."
          });
          this.cancelEdit();
          if(window.dt){
            window.dt.reload();
          }
          socket.emit("new-schedule", response.data);
        })
        .catch(error => {
          console.error("[methods -> delete()]:", error);
          return Swal.fire({
            type: "error",
            title: "Erro!",
            text: "Falha ao realizar a ação."
          });
        });
    },

    destroy() {
      let id;
      let path;
      if (this.modalMode == "default") {
        id = document.getElementById("costumerId").value;
        path = '/delete/';
      }
      if (this.modalMode == "callback") {
        id = document.getElementById("callbackId").value;
        path = '/deleteSchedule/';
      }
      if (this.modalMode == 'schedule') {
        id = document.getElementById("scheduleId").value;
        // path = '/delete/'
        path = '/schedule/destroy'
      }
      axios
        .delete(this.url + `${path}`, { data: { id } })
        .then(response => {
          Swal.fire({
            type: "success",
            title: "Feito!",
            text: "Excluído com sucesso."
          });
          this.cancelEdit();
          $("#costumerData").modal("hide");
          if(window.dt){
            window.dt.reload();
          }
          socket.emit("delete-schedule", response.data);
        })
        .catch(error => {
          console.error("[methods -> delete()]:", error);
          return Swal.fire({
            type: "error",
            title: "Erro!",
            text: "Falha ao realizar a ação."
          });
        });
    }
  }
};
</script>

